import { render, staticRenderFns } from "./SilomSuccess.vue?vue&type=template&id=060456fd&"
import script from "./SilomSuccess.vue?vue&type=script&lang=js&"
export * from "./SilomSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports